import React from "react";
import { FileText, Sparkles, Target, MessageCircleHeart } from 'lucide-react';

export default function TivComingSoonModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div
      className="absolute inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-slate-900 rounded-2xl p-6 max-w-sm w-full border-2 border-dashed border-pink-400/50"
        style={{ boxShadow: '0 0 30px rgba(244, 114, 182, 0.15)' }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Titre */}
        <h2 className="text-white text-xl font-bold text-center mb-2">
          Tiv arrive bientôt 🤍
        </h2>

        {/* Texte d'intro */}
        <p className="text-gray-400 text-sm text-center mb-5">
          Un nouvel assistant dédié à t'accompagner dans la rédaction de tes lettres de motivation Parcoursup.
        </p>

        {/* Liste des avantages */}
        <div className="bg-slate-800/50 rounded-xl p-4 mb-5 border border-slate-700">
          <p className="text-pink-300 text-sm font-medium mb-3">Bientôt, tu pourras :</p>
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <FileText size={18} className="text-pink-400" />
              <span className="text-gray-300 text-sm">Rédiger des lettres de motivation personnalisées</span>
            </div>
            <div className="flex items-center gap-3">
              <Target size={18} className="text-pink-400" />
              <span className="text-gray-300 text-sm">Adapter ton discours à chaque formation</span>
            </div>
            <div className="flex items-center gap-3">
              <Sparkles size={18} className="text-pink-400" />
              <span className="text-gray-300 text-sm">Mettre en valeur tes expériences et qualités</span>
            </div>
            <div className="flex items-center gap-3">
              <MessageCircleHeart size={18} className="text-pink-400" />
              <span className="text-gray-300 text-sm">Obtenir des conseils pour te démarquer</span>
            </div>
          </div>
        </div>

        {/* Phrase de conclusion */}
        <p className="text-gray-500 text-xs text-center mb-5">
          Tiv sera ton allié pour convaincre les formations qui te plaisent.
        </p>

        {/* Bouton principal */}
        <button
          onClick={onClose}
          className="w-full py-3 px-4 bg-pink-500 hover:bg-pink-400 text-white font-semibold rounded-xl transition-colors"
        >
          Compris, j'ai hâte !
        </button>
      </div>
    </div>
  );
}
